<template>
  <v-hover v-slot="{ hover }">
    <v-text-field v-model="boolText"
                  class="q-input"
                  :class="[BorderClass, CompactClass, BlurrClass, boolColor + '--inputtext', 'removeunderline']"
                  :background-color="BackgroundColor"
                  :label="labelText"
                  readonly
                  hide-details="auto"
                  :single-line="singleline"
                  :hoverbool="setHoverBool(hover)"
                  :color="boolColor"
                  flat>
      <!-- :rules="[required]" -->

      <!-- PREPEND SLOTS -->
      <template v-slot:prepend>
        <slot name="prepend-outer" />
      </template>

      <template v-slot:prepend-inner>
        <slot name="prepend" />
      </template>
      <!------------------->

      <!-- APPEND SLOTS -->
      <template v-slot:append>
        <v-checkbox v-if="!loading"
                    :input-value="newValue"
                    :disabled="disabled"
                    :readonly="IsDisabled"
                    :color="boolColor"
                    dense
                    :indeterminate="unTamperedIndeterminate"
                    :ripple="!IsDisabled"
                    :rules="rules"
                    hide-details
                    :true-value="trueValue"
                    :false-value="falseValue"
                    @change="e => changeBool(e)"
                    class="q-checkbox pa-0 ma-0">
        </v-checkbox>
        <v-progress-circular v-else
                             indeterminate
                             size="20"
                             width="2"
                             color="primary">
        </v-progress-circular>
        <ExternalChangeWarning v-if="externallychanged"
                               @Sync="(newValue = value, externallychanged = false)" />
      </template>

      <template v-slot:append-outer>
        <slot name="append-outer" />
      </template>
      <!------------------->

    </v-text-field>
  </v-hover>
</template>


<script>
import InputMixin from "@/helpers/Mixins/InputMixin";
import ExternalChangeWarning from "@/components/Inputs/Parts/ExternalChangeWarning.vue";

export default {
  name: "QCheckboxInput",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    label: String,
    value: Boolean,
    singleline: Boolean,
    disabled: Boolean,
    loading: Boolean,
    externaledit: Boolean,
    emitOnlyOnBlur: Boolean,
    rules: Array,

    boolcolors: Object,
    booltexts: Object,
    indeterminate: Boolean,
    trueValue:{
      //type: any,
      default: true,
    },
    falseValue:{
      //type: any,
      default: false,
    },
  },
  components: {
    ExternalChangeWarning,
  },
  mixins: [InputMixin],

  data() {
    return {
      edit: false,
      newValue: this.value,
      changedCount: 0,
    };
  },

  methods: {
    changeBool(val) {
      this.setEdit();
      this.newValue = val;
      this.changedCount++;
      this.blurInput();
    },
  },

  computed: {
    unTamperedIndeterminate() {
      return this.indeterminate && !this.changedCount;
    },

    state(){
        if(this.unTamperedIndeterminate){
        return 'indeterminate';
      }
      else if(this.newValue == this.trueValue){
        return 'true';
      }
      else{
        return 'false';
      }
    },

    boolText() {
      var text;
      switch (this.state) {
        case "indeterminate":
          text = this.booltexts?.indeterminate ?? this.$t("servicesystem.common_objects.commonterms.partially");
          break;
        case "true":
          text = this.booltexts?.true ?? this.$t("servicesystem.common_objects.commonterms.yes");
          break;
        default:
          text =  this.booltexts?.false ?? this.$t("servicesystem.common_objects.commonterms.no");
          break;
      }
      return text;
    },

    boolColor() {
      var color;
      switch (this.state) {
        case "indeterminate":
          color = this.boolcolors?.true ?? "primary";
          break;
        case "true":
          color = this.boolcolors?.indeterminate ?? "primary";
          break;
       default:
          color = this.boolcolors?.false ?? "tertiary";
          break;
      }
      return color;
    },
  },

  watch: {},
};
</script>

